import { MissionRecord } from "./types";

export const missionActive = (mission: MissionRecord): boolean =>
	!mission?.end_time;
